// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CountrySelector_wrapper__2hFh1","dropdownMenu":"CountrySelector_dropdownMenu__24SIT","dropdownItem":"CountrySelector_dropdownItem__3ycAx"};